import { put } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/settings/messages";
import { camelizeKeys } from "lib/helpers";

function* getAdminVolumeTiersSettings() {
  const { success, data, error } = yield* makeRequest.get("/revenue_tiers", {});

  if (success && data) {
    const volumeTiers = camelizeKeys(data.body.revenue_tiers);
    yield put(actions.setAdminVolumeTiersSettings(volumeTiers));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_VOLUME_TIERS,
    });
  }

  return null;
}

export default getAdminVolumeTiersSettings;
